<div class="flex items-center" *ngIf="data.title">
  <ng-container [ngTemplateOutlet]="icon"></ng-container>
  <div class="bold ml-10">{{ data.title }}</div>
</div>

<div class="flex items-center">
  <ng-container *ngIf="!data.title" [ngTemplateOutlet]="icon"></ng-container>
  <div class="mt-10 mb-10" [innerHTML]="data.bodyTemplate"></div>
</div>

<div class="flex justify-end">
  <button mat-button color="accent" *ngIf="data.ctaButton" (click)="snackBarRef.dismissWithAction()">
    {{ data.ctaButton }}
  </button>
  <button *ngIf="!data.disableCloseButton" mat-button color="accent" (click)="snackBarRef.dismiss()">Zamknij</button>
</div>

<ng-template #icon>
  <app-icon [name]="data.icon" [ngClass]="data.icon" class="mr-10"></app-icon>
</ng-template>
